import React, { useEffect, useMemo, useState } from "react";
import SpecialOffersModal from "../../../shared/components/modals/SpecialOffersModal";

const MODAL_COPY = {
  first_time: {
    title: "🎉 Welcome Bonus!",
    description: "Limited Time: Huge bonuses for new players",
  },
  second_time: {
    title: "🎉 Second Purchase Bonus!",
    description: "Special bonus for your second purchase",
  },
};

/**
 * Auto-opening welcome / second-purchase bonus modal.
 *
 * Driven by the player's purchase status (fetched once via the shared
 * usePurchaseStatus hook and passed down). When the status says to show the
 * modal, it opens after a short delay so it doesn't slam the player on first
 * paint. Module-scope component; the timer + open state live here, isolated
 * from the rest of the lobby.
 */
const WelcomeBonusModal = ({ purchaseStatus }) => {
  const [isOpen, setIsOpen] = useState(false);

  const modalType =
    purchaseStatus?.modalType === "second_time" ? "second_time" : "first_time";
  const copy = useMemo(() => MODAL_COPY[modalType], [modalType]);

  useEffect(() => {
    if (!purchaseStatus?.shouldShowWelcomeModal) return;
    const timer = setTimeout(() => setIsOpen(true), 1000);
    return () => clearTimeout(timer);
  }, [purchaseStatus?.shouldShowWelcomeModal]);

  return (
    <SpecialOffersModal
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      filterType={modalType}
      title={copy.title}
      description={copy.description}
    />
  );
};

export default WelcomeBonusModal;
